import {Injectable} from "@angular/core";
import {api} from "../connect-api";
import {LocationStrategy, PathLocationStrategy} from "@angular/common";
import {HttpClient} from "@angular/common/http";
import {Utils} from "../utils";
import {ApplicationLog} from "./application-log";
import {SESSION_STORAGE_KEYS} from "../session-storage-keys";
import {CustomHttpParams} from "../connect-http-interceptor";

export type LogLevelType = 'WARN' | 'INFO' | 'DEBUG';
export class LogLevelTypeValues {
    public static readonly WARN: LogLevelType = 'WARN';
    public static readonly INFO: LogLevelType = 'INFO';
    public static readonly DEBUG: LogLevelType = 'DEBUG';
}

export const ClientSideDriverLicenseParsing = 'CLIENT_SIDE_DRIVER_LICENSE-PARSING: ';
export const ServerSideDriverLicenseParsing = 'SERVER_SIDE_DRIVER_LICENSE-PARSING: ';

export const HowManySecondsAnUserCanWaitForAnAPICall = 60; // it should be 4 seconds

@Injectable({
    providedIn: 'root'
})
export class GlobalLoggerService {
    private loggerUrl = (userId: string, level: LogLevelType) => `${api}/users/${userId}/logFromClientSide/${level}`;

    constructor(private location: LocationStrategy,
                private httpClient: HttpClient
    ){}

    log(level: LogLevelType, msg: string, stackTrace?: string) {
        const url = this.location instanceof PathLocationStrategy
            ? this.location.path() : '';

        let applicationLog: ApplicationLog = new ApplicationLog();
        applicationLog.message = msg;
        applicationLog.url = url;
        applicationLog.browserInfo =  Utils.getBrowserInfo();
        applicationLog.status = null;
        applicationLog.stack = stackTrace ? stackTrace : null;
        applicationLog.accountId = sessionStorage.getItem(SESSION_STORAGE_KEYS.customerAccountId);
        applicationLog.userId = sessionStorage.getItem(SESSION_STORAGE_KEYS.userId);

        let apiUrl = this.loggerUrl(sessionStorage.getItem(SESSION_STORAGE_KEYS.userId), level);
        this.httpClient.post(apiUrl, JSON.stringify(applicationLog), {
            params: new CustomHttpParams(true)
        }).subscribe();

    }

    logDuration(startTime: number, action: string){
        const duration = Math.round((performance.now() - startTime) / 1000);
        if (duration > HowManySecondsAnUserCanWaitForAnAPICall) {
            this.log(LogLevelTypeValues.WARN, `${action} completed in ${duration} seconds`);
        }
    }
}
